import React, { useState, useMemo, useEffect } from 'react';

export default function MergeLeadsModal({ cluster, clusters: clustersProp, onClose, onMerge }) {
  const clusterKey = useMemo(
    () => clustersProp?.map(c => (c.leads || []).map(l => l.id).join(',')).join('|') ?? (cluster?.leads ? (cluster.leads || []).map(l => l.id).join(',') : ''),
    [clustersProp, cluster],
  );

  const clusters = useMemo(() => {
    if (Array.isArray(clustersProp) && clustersProp.length) return clustersProp.filter(c => (c?.leads || []).length >= 2);
    if (cluster?.leads?.length >= 2) return [cluster];
    return [];
  }, [clusterKey]);

  const [clusterIdx, setClusterIdx] = useState(0);
  useEffect(() => {
    setClusterIdx(0);
  }, [clusterKey]);

  const activeCluster = clusters[clusterIdx] || null;
  const leads = activeCluster?.leads || [];
  const [primaryId, setPrimaryId] = useState(() => leads[0]?.id);

  useEffect(() => {
    setPrimaryId(leads[0]?.id);
  }, [clusterIdx, activeCluster?.leads?.[0]?.id]);

  const others = useMemo(() => leads.filter(l => String(l.id) !== String(primaryId)), [leads, primaryId]);

  if (!clusters.length || leads.length < 2) return null;

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 5000, background: 'rgba(15,23,42,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
      onClick={e => { if (e.target === e.currentTarget) onClose?.(); }}>
      <div style={{ width: 520, maxWidth: '100%', background: 'var(--bg2)', borderRadius: 14, border: '1px solid var(--border)', boxShadow: '0 20px 60px rgba(0,0,0,0.2)', padding: 22 }}>
        <div style={{ fontSize: 18, fontWeight: 800, color: 'var(--text)', marginBottom: 6 }}>Duplikate zusammenführen</div>
        <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 16 }}>Aktivitäten werden in den Ziel-Kontakt gemerged; andere Kontakte werden entfernt.</div>

        {clusters.length > 1 && (
          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text3)', textTransform: 'uppercase', marginBottom: 6 }}>Duplikat-Gruppe</div>
            <select value={clusterIdx} onChange={e => setClusterIdx(Number(e.target.value))} style={{ width: '100%', height: 40, borderRadius: 8, border: '1px solid var(--border)', background: 'var(--bg3)', color: 'var(--text)', padding: '0 10px' }}>
              {clusters.map((c, i) => (
                <option key={i} value={i}>
                  Gruppe {i + 1} · {c.leads.length} Kontakte · {(c.leads[0]?.name || '').slice(0, 28)}{(c.leads[0]?.name || '').length > 28 ? '…' : ''}
                </option>
              ))}
            </select>
          </div>
        )}

        <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text3)', textTransform: 'uppercase', marginBottom: 6 }}>Ziel-Kontakt (bleibt erhalten)</div>
        <select value={primaryId} onChange={e => setPrimaryId(e.target.value)} style={{ width: '100%', height: 40, borderRadius: 8, border: '1px solid var(--border)', marginBottom: 14, background: 'var(--bg3)', color: 'var(--text)', padding: '0 10px' }}>
          {leads.map(l => (
            <option key={l.id} value={l.id}>{l.name} · {l.company} · {l.tel || '–'}</option>
          ))}
        </select>

        <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text3)', textTransform: 'uppercase', marginBottom: 6 }}>Wird zusammengeführt (wird gelöscht)</div>
        <ul style={{ margin: 0, paddingLeft: 18, fontSize: 13, color: 'var(--text2)' }}>
          {others.map(l => (
            <li key={l.id}>{l.name} · {l.company}</li>
          ))}
        </ul>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 22 }}>
          <button type="button" onClick={onClose} style={{ height: 38, padding: '0 16px', borderRadius: 8, border: '1px solid var(--border)', background: 'var(--bg3)', cursor: 'pointer' }}>Abbrechen</button>
          <button type="button" onClick={() => onMerge?.(primaryId, others.map(l => l.id))}
            style={{ height: 38, padding: '0 16px', borderRadius: 8, border: 'none', background: '#dc2626', color: '#fff', fontWeight: 700, cursor: 'pointer' }}>
            Jetzt mergen
          </button>
        </div>
      </div>
    </div>
  );
}
